import { useCallback } from "react";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import { MAINNET_CHAINID } from "../config";
import setupNetwork from "../utils/setupNetwork";
import { connectorsByName } from "../components/ConnectWalletModal";
import {
  connectorLocalStorageKey,
  ConnectorNames,
} from "../components/ConnectWalletModal/connectors";

const useAuth = () => {
  const { activate, deactivate } = useWeb3React();
  const login = useCallback(
    (connectorID: ConnectorNames) => {
      const connector = connectorsByName[connectorID];
      if (!connector) {
        console.error("Can't find connector", "The connector config is wrong");
        return;
      }

      const handleError = (error: unknown) => {
        if (error instanceof UnsupportedChainIdError) {
          void (async () => {
            const hasSetup = await setupNetwork(MAINNET_CHAINID);
            if (hasSetup) {
              activate(connector, (e: Error) => handleError(e));
            }
          })();
          return;
        }
        const name =
          error && typeof (error as Error).name === "string"
            ? (error as Error).name
            : "";
        const message =
          error && typeof (error as Error).message === "string"
            ? (error as Error).message
            : String(error);
        console.error("Error while connecting to wallet:", name, message);
        try {
          window.localStorage.removeItem(connectorLocalStorageKey);
        } catch {
          /* ignore */
        }
      };

      if (connectorID === ConnectorNames.Injected) {
        if (typeof window === "undefined" || !(window as WindowChain).ethereum) {
          console.error(
            "Error while connecting to wallet:",
            "No injected provider",
            "Install MetaMask (or another EVM wallet) or use WalletConnect."
          );
          return;
        }
      }

      activate(connector, (error: Error) => handleError(error));
    },
    [activate]
  );

  return {
    login,
    logout: deactivate,
  };
};

export default useAuth;
